function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 31.993,
  cy: 31.993,
  r: 31.295,
  fill: "#FFF8FA",
  stroke: "#CA3232",
  strokeWidth: 1.397,
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#CA3232",
  strokeWidth: 1.17,
  d: "M33.914 9.062c.041 6.437 1.15 12.426 4.522 17.83.813 1.304 1.798 2.508 2.766 3.71.635.788.997 1.575.523 2.549-.455.936-1.25 1.211-2.26 1.168-5.245-.222-10.394.454-15.48 1.672-1.107.265-1.963.003-2.687-.918-4.351-5.539-7.047-11.766-8.099-18.698-.738-4.87-.7-9.727.186-14.572C13.671.24 15.184-.471 16.56.334c2.805 1.642 5.79 2.808 9.04 3.096 1.941.172 3.917.134 5.865.011 1.61-.101 2.664.701 2.608 2.31-.04 1.167-.11 2.333-.158 3.311",
  transform: "matrix(-1 0 0 1 53.06 14.485)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CA3232",
  d: "M19.508 34.138c-3.127-2.533-5.67-5.576-7.806-8.947-3.24-5.117-5.489-10.62-6.607-16.551-.101-.535-.188-1.078-.215-1.62-.06-1.193.82-2.183 2.008-2.142 1.69.058 3.377.23 5.14.358-.06.448-.11.825-.171 1.296-1.369-.119-2.709-.216-4.044-.355-1.416-.147-1.684.055-1.518 1.443.45 3.767 1.722 7.305 3.265 10.755 1.752 3.916 4.042 7.505 6.751 10.866 1.22 1.513 2.14 3.258 3.197 4.897",
  transform: "matrix(-1 0 0 1 53.06 14.485)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CA3232",
  d: "M16.471 34.138c-1.247-.92-2.54-1.782-3.735-2.768C6.519 26.24 2.298 19.768.146 11.935c-.14-.513-.193-1.1-.098-1.616.173-.932.999-1.561 1.917-1.54.592.013 1.182.134 1.78.207.09.436.17.818.274 1.328-.528-.062-.977-.125-1.427-.164-1.239-.106-1.603.261-1.184 1.44.844 2.37 1.65 4.771 2.733 7.031 1.977 4.125 4.824 7.606 8.16 10.711 1.538 1.431 2.86 3.1 4.28 4.66l-.11.146",
  transform: "matrix(-1 0 0 1 53.06 14.485)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 55.485,
  cy: 53.828,
  r: 11.705,
  fill: "#FFF",
  stroke: "#CA3232"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CA3232",
  fillRule: "nonzero",
  stroke: "#CA3232",
  strokeWidth: 0.5,
  d: "M56.76 54l4.059-4.076c.217-.217.217-.562 0-.761-.218-.217-.562-.217-.761 0L56 53.239l-4.076-4.076c-.217-.217-.562-.217-.761 0-.217.217-.217.562 0 .76L55.221 54l-4.058 4.076c-.217.217-.217.562 0 .761.109.109.254.163.38.163.127 0 .272-.054.38-.163L56 54.761l4.076 4.076c.109.109.254.163.38.163.127 0 .272-.054.381-.163.217-.217.217-.562 0-.76L56.761 54z"
}));

function SvgNocardboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNocardboard);
export default __webpack_public_path__ + "static/media/nocardboard.d3f34d9a.svg";
export { ForwardRef as ReactComponent };